const Cookies = require('js-cookie')
const instrument = require('@adc/instrument')
const graph = require('@adc/sdk')
const eventNames = require('./eventNames')
const standardTracking = require('./standardTracking')
const helpers = require('./helpers')

function track(event, props = {}) {
  typeof window !== 'undefined' &&
    window.dataLayer &&
    window.dataLayer.push({
      event,
      ...props,
    })
}

function trackDataLayerLoaded(user = {}, additionalData = {}) {
  track(eventNames.dataLayerLoaded, {
    cookieId: Cookies.get('BRID'),
    userLoggedIn: user.logged_in,
    ...(user?.logged_in ? standardTracking.user(user) : {}),
    ...additionalData,
  })
}

function trackPropertySave(listing, action, additionalData = {}) {
  track(eventNames.propertySave, {
    action,
    status: 'success',
    ...additionalData,
    ...standardTracking.listing(listing),
  })
}

const trackInstrumentPageLoad = (user = {}, productLine) => {
  instrument.default.domainEvent({
    type: graph.enums.DomainEventTypeName.PageViewed,
    source: helpers.getUrn(user),
    data: {
      product_line: productLine,
    },
  })
}

// remove this, call it from apps and just pass in listing.urn
const trackUserDomainEvent = ({ domainEventTypeName, user, data = {} }) => {
  instrument.default.domainEvent({
    type: domainEventTypeName,
    source: helpers.getUrn(user),
    data,
  })
}

module.exports = {
  eventNames,
  track,
  trackDataLayerLoaded,
  trackPropertySave,
  trackInstrumentPageLoad,
  trackUserDomainEvent,
}
